import 'babel-polyfill'
import whatInput from 'what-input'

import './header'
import './nav'
import initReveal from './reveal'
import initCounters from './counters'
import initHeroIntro from './heroIntro'
import initStack from './stack'
import initMarquee from './marquee'
import initWhyCarousel from './whyCarousel'
import initSectors from './sectors'

function initMotion() {
	const root = document.documentElement

	try {
		initReveal()
		initCounters()
		initHeroIntro()
		initStack()
		initMarquee()
		initWhyCarousel()
		initSectors()
		root.classList.add('motion-ready')
	} catch (error) {
		/* Never leave content hidden behind a motion system that failed to start. */
		root.classList.remove('has-motion')
		root.classList.add('motion-ready')
		if (window.console) console.error(error)
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initMotion)
} else {
	initMotion()
}
